import { cn } from '../lib/utils';

/**
 * The No Half Days sun, in one colour. Ink on the light theme's sand, sand on
 * the dark theme and on inverse bands. `onInverse` is for a mark sitting on an
 * inverse band, where the colours swap. The coral original (/logo.png) stays
 * in PDFs, email and the favicon.
 */
export function Logo({ className, onInverse = false, alt = 'No Half Days' }) {
  const light = onInverse ? '/logo-sand.png' : '/logo-ink.png';
  const dark = onInverse ? '/logo-ink.png' : '/logo-sand.png';
  return (
    <>
      <img src={light} alt={alt} className={cn('object-contain dark:hidden', className)} decoding="async" />
      <img src={dark} alt={alt} className={cn('hidden object-contain dark:block', className)} decoding="async" />
    </>
  );
}
